module.exports = __webpack_public_path__ + "assets/img/fba53e97d7ea07c30dce37cf6921a49b.png";